import { WatchAPI } from 'lib/api';

export const START_GET_SCHEDULE = 'START_GET_SCHEDULE';
export const COMPLETE_GET_SCHEDULE = 'COMPLETE_GET_SCHEDULE';
export const START_GET_CATEGORIES = 'START_GET_CATEGORIES';
export const COMPLETE_GET_CATEGORIES = 'COMPLETE_GET_CATEGORIES';
export const SET_STATUS_FILTER = 'SET_STATUS_FILTER';
export const SET_SPORTS_FILTER = 'SET_SPORTS_FILTER';
export const SET_NETWORK_FILTER = 'SET_NETWORK_FILTER';
export const SET_DATE_FILTER = 'SET_DATE_FILTER';
export const SET_REPLAY_DATE_FILTER = 'SET_REPLAY_DATE_FILTER';

export function startGetSchedule() {
    return {
        type: START_GET_SCHEDULE,
        startTime: Date.now()
    };
}

export function completeGetSchedule(listings) {
    return {
        type: COMPLETE_GET_SCHEDULE,
        completeTime: Date.now(),
        listings
    };
}

export function setStatusFilter(status) {
    return {
        type: SET_STATUS_FILTER,
        status
    };
}
export function getQueryFromParams(params) {
    const types = params.type ? [params.type] : ['live'];
    const categories = params.categoryId ? [params.categoryId] : [];
    const networks = (params.channel || '').toLowerCase();
    const startDate = params.startDate;
    const endDate = params.endDate;
    const dates = [startDate, endDate];
    return { types, networks, categories, dates };
}

export function fetchSchedule(params) {
    return (dispatch, getState) => {
        dispatch(startGetSchedule());
        // filtering channels is a bit of a different beast, as the API url is not calculated, but determined via state
        let listingsHref;
        if (params.channel) {
            const state = getState();
            const channels = (state && state.schedule && state.schedule.channels) || [];
            const matchedChannel = channels.filter((channel) => (channel.abbreviation === params.channel)).shift();
            if (matchedChannel) {
                listingsHref = (matchedChannel.links && matchedChannel.links.api && matchedChannel.links.api.listings
                    && matchedChannel.links.api.listings.href) || null;
            }
        }

        const query = getQueryFromParams(params);
        return WatchAPI.getListings(query, listingsHref).then((listings) => {
            dispatch(completeGetSchedule(listings));
            return listings;
        });
    };
}

export function startGetCategories() {
    return {
        type: START_GET_CATEGORIES,
        startTime: Date.now()
    };
}

export function completeGetCategories(categories) {
    return {
        type: COMPLETE_GET_CATEGORIES,
        completeTime: Date.now(),
        categories
    };
}

export function fetchCategories() {
    return (dispatch) => {
        dispatch(startGetCategories);
        return WatchAPI.getCategories().then((categories) => {
            dispatch(completeGetCategories(categories));
            return categories;
        });
    };
}

export function setSportsFilter(option) {
    return {
        type: SET_SPORTS_FILTER,
        value: option.value,
        filterType: option.type,
        label: option.label
    };
}

export function setNetworkFilter(option) {
    return {
        type: SET_NETWORK_FILTER,
        value: option.value,
        label: option.label
    };
}

export function setDateFilter(date) {
    return {
        type: SET_DATE_FILTER,
        date
    };
}

export function setReplayDateFilter(startDate, endDate) {
    return {
        type: SET_REPLAY_DATE_FILTER,
        startDate,
        endDate
    };
}



// WEBPACK FOOTER //
// ./app/schedule/actions/index.js